export default "__VITE_ASSET__BlUxdkPR__"